import { useCallback } from "react";
import { v4 } from "uuid";
import { trackEvent } from "../../../../utils/analytics";
import type { Nurse } from "../../../../utils/models";
import { usePostStaffMessage } from "../hooks";

type useDirectMessagesProps = {
	onClose: () => void;
};

export const useDirectMessages = ({ onClose }: useDirectMessagesProps) => {
	const { mutateAsync: postBroadcastMessage, isPending: isLoading, isSuccess } = usePostStaffMessage();

	const handleSendMessage = useCallback(
		async (message: string, nurse: Nurse): Promise<void> => {
			if (!nurse.userId) return;

			await postBroadcastMessage({
				message: message.trim(),
				userIds: [nurse.userId],
				tempId: v4(),
			});
			trackEvent("send_direct_message", { message, nurseId: nurse.id });
			onClose();
		},
		[onClose, postBroadcastMessage],
	);

	return { handleSendMessage, isLoading, isSuccess };
};
